import STUDENT_FEATURES from '../../constants/student-features';
import VTWA_GRADE_IDS from '../../constants/grade-ids';
import mapGradeLevelToVtwaGradeIds from '../../utilities/cms/map-grade-level-to-vtwa-grade-ids';
import useNspContent from '@llt-frontend/react-nsp';
import useUserContext from '../context/use-user-context';

//

const PRODUCT_TYPE = 'catalog_access';

//

function _isGradeAppropriateContent(content, studentGrade) {
  if (
    !content.gradeLevelTargets.length ||
    !studentGrade ||
    VTWA_GRADE_IDS.groupings.unmapped.includes(studentGrade)
  ) {
    return true;
  }

  return Boolean(
    content.gradeLevelTargets.filter(
      ({ gradeLevel }) =>
        gradeLevel === 'All' || mapGradeLevelToVtwaGradeIds(gradeLevel).includes(studentGrade)
    ).length
  );
}

// Exports
// -------

export default function useStudentOnDemandCoursesContent({ gradeAppropriateOnly = false } = {}) {
  const labUser = useUserContext();
  const studentGrade = labUser.activeStudent?.grade;

  //
  // Result

  return useNspContent({
    query: `
      query AllOnDemandCoursePages {
        allLlOnDemandCoursePages(orderBy: [name_ASC]) {
          slug
          id
          name
          pageIcon
          pageThumbnail {
            url
            alt
          }
          relatedProductIdentifiers {
            id
            identifier
            productType
          }
          gradeLevelTargets {
            gradeLevel
          }
        }
      }
    `,
    apiHost: process.env.REACT_APP_API_HOST,
    preview: process.env.REACT_APP_NSP_PREVIEW === 'true',
    queryId: process.env.REACT_APP_NSP_ON_DEMAND_COURSE_QUERY_ID,
    queryOptions: {
      enabled: !labUser.loading,
      select({ data } = {}) {
        return (
          data?.allLlOnDemandCoursePages?.filter(
            (content) =>
              (labUser.hasContentAccess(content, PRODUCT_TYPE) ||
                labUser.activeStudent?.hasEnablement(STUDENT_FEATURES.academicVideoOnDemand)) &&
              (!gradeAppropriateOnly || _isGradeAppropriateContent(content, studentGrade))
          ) || []
        );
      },
    },
  });
}
